import moment from "moment";

const HOTEL_BIRTHDAY_PROMO = {
  enabled: true,
  partnerId: "POUPAS",
  discountPercent: 9,
  startDate: "2026-04-01",
  endDate: "2026-04-10",
  hotelIds: [] as string[],
  bannerText: {
    prefix: "Γιορτάζουμε & για ",
    highlightDays: "9 μέρες",
    dateRange: "(1-9 Απριλίου)",
    middle: " σας δίνουμε ",
    highlightDiscount: "-9%",
    suffix: " σε επιλεγμένα ξενοδοχεία Κύπρου.",
  },
  imagePath: "/assets/Birthday_Offer.png",
};

const matchesPartner = (partnerId?: string) =>
  (partnerId || "").toUpperCase() === HOTEL_BIRTHDAY_PROMO.partnerId;

const matchesHotel = (hotelId?: string) =>
  HOTEL_BIRTHDAY_PROMO.hotelIds.length === 0 ||
  (!!hotelId && HOTEL_BIRTHDAY_PROMO.hotelIds.includes(hotelId));

export const isHotelBirthdayPromoActive = ({
  partnerId,
  hotelId,
  now,
}: {
  partnerId?: string;
  hotelId?: string;
  now?: moment.Moment;
}) => {
  if (!HOTEL_BIRTHDAY_PROMO.enabled) return false;
  if (!matchesPartner(partnerId)) return false;
  if (!matchesHotel(hotelId)) return false;
  const currentMoment = now || moment();
  const startMoment = moment(HOTEL_BIRTHDAY_PROMO.startDate, "YYYY-MM-DD");
  const endMoment = moment(HOTEL_BIRTHDAY_PROMO.endDate, "YYYY-MM-DD");
  return (
    (currentMoment.isAfter(startMoment, "day") ||
      currentMoment.isSame(startMoment, "day")) &&
    (currentMoment.isBefore(endMoment, "day") ||
      currentMoment.isSame(endMoment, "day"))
  );
};

export const applyHotelBirthdayPromo = ({
  price,
  partnerId,
  hotelId,
}: {
  price?: number;
  partnerId?: string;
  hotelId?: string;
}) => {
  const numericPrice = Number(price);
  if (!Number.isFinite(numericPrice)) return numericPrice;
  if (!isHotelBirthdayPromoActive({ partnerId, hotelId })) return numericPrice;
  return Math.round(
    numericPrice * ((100 - HOTEL_BIRTHDAY_PROMO.discountPercent) / 100),
  );
};

export const hotelBirthdayPromoConfig = HOTEL_BIRTHDAY_PROMO;
